module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsChristmas.304453b.jpg";